
<template>

	<mymodal ref="modal" title="Конструктор корректировки" without_ok :reset="reset" :check="check" width="1600px" :cancel_func="cancel" cancel="Закрыть">

		<b-row class="mt-2" align-v="center">
			<b-col cols="2">Наименование конструктора</b-col>
			<b-col><b-form-input :state="name_state" v-model="name" v-on:input="check"/></b-col>
		</b-row>

		<b-row>
			<b-col cols="2"/>
			<b-col><b-form-invalid-feedback :state="name_state">Необходимо ввести наименование</b-form-invalid-feedback></b-col>
		</b-row>

		<b-row class="mt-2" align-v="center">
			<b-col cols="2">Тип корректировки</b-col>
			<b-col style="height: 100%;"><v-select style="height: 100%;" :options="correction_types" v-model="correction_type" :state="correction_type_state" required appendToBody :clearable="false" :disabled="!!id"/></b-col>
			<b-col cols="2">Порядок применения</b-col>
			<b-col>
				<v-select :options="orders" v-model="order" :state="order_state" :clearable="false" @input="check" required appendToBody>
					<template #search="{ attributes, events }">

						<input class="vs__search" v-bind="attributes" v-on="events"/>
						<div v-if="! order_state" class="v_select_invalid_icon" />

					</template>
				</v-select>
			</b-col>
		</b-row>

		<b-row>

			<b-col cols="2"/>
			<b-col><b-form-invalid-feedback :state="correction_type_state">Необходимо выбрать тип</b-form-invalid-feedback></b-col>
			<b-col cols="2"/>
			<b-col><b-form-invalid-feedback :state="order_state">Необходимо указать порядок применения</b-form-invalid-feedback></b-col>

		</b-row>

		<div class="mt-2" style="min-height: 310px">
			<stage class="mt-2 mr-2" ref="code"
				:attrs="attrs_all" :attr_type="attr_type" :attr_reference="attr_reference"
				:disabled="! ( name_state && correction_type_state )" :has_empty="false" v-on:need_check="() => constructor_need_refresh()"
				first_stage is_correction :is_correction_mult="correction_type == 'Мультипликативная'" in_doing
			/>
		</div>

		<template v-slot:buttons>

			<b-button class="mx-1" variant="primary" :disabled="! check()" v-on:click="() => save()">Сохранить</b-button>

		</template>

	</mymodal>

</template>

<script>

import api from "../../../../../../api"
import mymodal from "../../../../../widgets/modal"
import stage from "../../../../scripts/stage"
import Reference_controller from "../controller";

export default
{
	props :
	{
		service : String,
		controller : Reference_controller
	},

	components :
	{
		mymodal,
		stage
	},

	data()
	{
		return {
			id : null,

			name_state : null,
			correction_type_state : null,
			order_state : null,

			name : null,
			correction_type : "Мультипликативная",
			order : null,

			correction_types : [],
			orders : [],

			attr_type : "number",
			attr_reference : null,


			attrs_all : [],
			attrs_base : [],
			attrs : [],

			code : "",

			saved : true,

		}
	},

	async beforeMount()
	{
		api.call(this, "cadastral", "get_reference", { reference : "correction_types" }, response => { this.correction_types = response.reference })

		if (!this.controller.attrs)
		{
			await new Promise((resolve) => this.controller.bus.$on("attrs_ready", () => resolve()))
		}

		this.attrs_all = this.controller.data.factors.map((id) => this.controller.attrs.find((attr) => attr.id == id))
	},

	watch :
	{
		correction_type()
		{
			this.$refs.code.clear()
		}
	},

	methods :
	{
		check()
		{
			var code_state = false
			var new_code

			this.name_state = !!this.name
			this.correction_type_state = !!this.correction_type
			this.order_state = !!this.order

			try
			{				
				if (this.$refs.code)
				{
					new_code = this.get()

					code_state = this.$refs.code.type != "+ Добавить"
				}
			}
			// eslint-disable-next-line
			catch (exp) { console.log(exp) }

			const state = this.name_state && this.correction_type_state && this.order_state && code_state
			
			this.saved = state && this.code == new_code

			return state
		},

		reset()
		{
			this.name_state = null
			this.correction_type_state = null
			this.order_state = null

			this.name = null
			this.correction_type = "Мультипликативная"

			this.code = ""

			this.check()
		},

		execute(id)
		{
			this.id = id

			api.call(this, "cadastral_script", "get_many", { query : { group : this.controller.group_id } },
				response =>
				{
					var existed_orders = []
					var orders = []

					response.data.forEach(cor => existed_orders.push(cor.order))

					for(let v = 1; v < 20; v++)
					{
						if(existed_orders.findIndex(order => order == v) < 0)
							orders.push(v)
					}

					this.orders = orders

					this.$refs.modal.execute()

					this.$nextTick(
						() =>
						{
							if(id)
							{
								api.call(this, this.service, "get", { id : id },
									response =>
									{
										this.name = response.data.name
										this.correction_type = response.data.correction_type
										this.code = response.data.code
										this.order = response.data.order
		
										this.load(response.data.code)
									})
							}
							else
							{
								this.name = null
								this.correction_type = "Мультипликативная"
								this.order = null
		
								this.check()
							}
						})
				})

		},

		constructor_need_refresh()
		{
			this.$refs.modal.$forceUpdate()
		},

		get()
		{
			return JSON.stringify(this.$refs.code.get())
		},

		load(raw)
		{
			this.$nextTick(
				() =>
				{
					const desc = JSON.parse(raw)

					this.$refs.code.load(desc)
				})
		},

		save(func)
		{
			const save_func =
			( close_after_save = false ) =>
			{
				const params =
				{
					name : this.name,
					order : this.order,
					code : this.get(),
				}

				if (this.id)
				{
					params.id = this.id

					api.call(this, this.service, "save", params,
					() =>
					{
						api.show_notification(this, "Изменения сохранены")
						this.saved = true
						this.code = params.code

						this.$emit("need_refresh")

						if(func)
							func(this.id)

						if(close_after_save)
							this.$refs.modal.my_hide()
					})
				}

				else
				{
					params.group = this.controller.group_id
					params.correction_type = this.correction_type,

					api.call(this, this.service, "add", { data : params },
						response =>
						{
							api.show_notification(this, "Изменения сохранены")
							this.saved = true
							this.code = params.code
							this.id = response.id

							this.$emit("need_refresh")

							if(func)
								func(response.id)

							if(close_after_save)
								this.$refs.modal.my_hide()
					})
				}
			}

			api.call(this, this.service, "get_by", { field : "name", value : this.name },
				(response) => {
					if(response?.data?.id)
					{
						if (response.data.id == this.id)
						{
							save_func()
						}
						else
						{
							this.$bvModal.msgBoxConfirm(
								"Обновить конструктор с таким наименованием?",
								{
									title : "Обновить конструктор",
									okVariant : "primary",
									okTitle : "Да",
									cancelTitle : "Нет",
									hideHeaderClose : false,
									centered : true
								})
								.then(
									value =>
									{
										if(value)
											api.call(this, this.service, "delete", { id : response.data.id },
											() => save_func()
										)
									})
						}
					}
					else
						api.show_error_box(self, response)
				},
				(self, response) => {
					if(response?.exception == "ObjectNotFound")
					{
						save_func()
					}
					else
						api.show_error_box(self, response)
				}
			)
		},

		cancel()
		{
			if(this.saved)
				this.$refs.modal.my_hide()
			else
				this.$bvModal.msgBoxConfirm(
					"Были внесены изменения. Сбросить изменения?",
					{
						title : "Изменения",
						okVariant : "danger",
						okTitle : "Да",
						cancelTitle : "Нет",
						hideHeaderClose : false,
						centered : true
					})
					.then(
						value =>
						{
							if(value)
								this.$refs.modal.my_hide()
						})
		},
	}
}

</script>


